import { createFileRoute } from '@tanstack/react-router'
import { CRT_ROUTES, toStaticData } from '../crt-route-config'

export const Route = createFileRoute('/_auth/_modules/crt/variance-analysis')({
  staticData: toStaticData(CRT_ROUTES['/crt/variance-analysis']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
